import NavbarTopAdmin from './components/navbarTopAdmin'
import NavbarBottomAdmin from './components/navbarBottomAdmin'
import AddEventi from './components/addEventi'
import AuthProvider from '../Authentication/authProvider'
import { Link } from 'react-router-dom'

function HomeAdmin() {

  return (<>
    <NavbarTopAdmin />
    <NavbarBottomAdmin />
    <AuthProvider />
    <div className='row gx-0 gy-4 p-3' style={{marginTop: '5em'}}>
      <div className='col-3'><Link to='/'>Home</Link></div>
      <div className='col-3'><Link to='/cosaFare'>Cosa fare</Link></div>
      <div className='col-3'><Link to='/preferiti'>Preferiti</Link></div>
      <div className='col-3'><Link to='/artisti'>Artisti</Link></div>
      <div className='col-3'><Link to='/foodTruck'>Ristoranti</Link></div>
      <div className='col-3'><Link to='/newsletter'>Newsletter</Link></div>
    </div>
    <AddEventi />
  </>
  )
}
export default HomeAdmin